<template>
  <div class="mit-keys-list">
    <MitDataTableClient
      title="Keys"
      :editable="false"
      :headers="headers"
      :items="keys"
    >
      <template v-slot:tableHeader="{ title, search }">
        <v-select style="max-width:150px;" class="doNotPrint pr-3" hide-details label="Inventory" v-model="invSelected" :items="invTypes" item-text="name" item-value="id" @change="updateInventoryType"></v-select>
        <v-text-field style="max-width:75px;" class="doNotPrint pr-5" hide-details v-model.number="invLTE" type="number" label="Less Than" @change="updateInventoryCount"></v-text-field>
        <v-spacer class="hideOnMobile"></v-spacer>
        <v-text-field
          class="search-text doNotPrint"
          v-model="search.text"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        >
        </v-text-field>
      </template>

      <!-- <template v-slot:item.data.notes="{ item, search }">
        <MitKeyNotes v-if="item.data.notes" :search="search" :notes="item.data.notes" />
      </template> -->

      <template v-slot:item.accessSpacesDisplay="{ item, search }">
        <MitKeySpaces :search="search" :spaces="item.accessSpacesDisplay" />
      </template>
      <template v-slot:item.accessSpacesDisplay-mobile="{ item, search }">
          <span>
          Spaces:<MitKeySpaces size="small" :dark="false" :search="search" :spaces="item.accessSpacesDisplay" /><br/>
          </span>
      </template>

      <template v-slot:item.spacesDisplay="{ item, search }">
        <MitKeySpaces :search="search" :spaces="item.spacesDisplay" :spacesDetails="item.spaces" />
      </template>
      <template v-slot:item.spacesDisplay-mobile="{ item, search }">
          <span>
          Spaces:<MitKeySpaces size="small" :dark="false" :search="search" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/><br/>
          </span>
      </template>
    </MitDataTableClient>
  </div>
</template>

<script>
import MitKeysService from '../../services/MitKeysService.js';

import MitDataTableClient from '../common/MitDataTableClient.vue';
import MitKeySpaces from './MitKeySpaces.vue';
import MitKeyNotes from '../keys/MitKeyNotes.vue';

export default {
  name: 'MitKeysCountsList',
  components: {
    MitDataTableClient,
    MitKeySpaces,
    MitKeyNotes
  },
  props: {},
  data: function() {
    return {
      search: '',
      headers:[
        {text: 'Name',align: 'start',sortable: true,value: 'name', width: '10%', filterable:true, mobile:true},
        {text: 'Available',sortable: true,value: 'numberAvailable', width: '10%', filterable:false, mobile:true},
        {text: 'Spaces',sortable: false,value: 'spacesDisplay',filterable:true},
        {text: 'Notes', sortable: false, value: 'data.notes', width: '25%', filterable:true}
      ],
      headersOptions:{
        count: {text: 'Total',sortable: true,value: 'count', width: '7%', filterable:false, mobile:true},
        available: {text: 'Available',sortable: true,value: 'numberAvailable', width: '10%', filterable:false, mobile:true},
      },
      keys:[],
      invTypes:[
        {name:'Total Count', id:'count'},
        {name:'Available', id:'available'}
      ],
      invSelected:'available',
      invLTE:2
    }
  },
  mounted() {
    this.refresh();
  },
  methods : {
    refresh() {
      MitKeysService.requestGetKeys({count:this.invSelected, orderBy:this.invSelected, number:this.invLTE-1})
        .then((data) => {
          this.keys = data;
        })
        .catch((error) => {
          console.log('An error occurred trying to get keys list', error);
        });
    },
    updateInventoryType(inv){
      let index = -1;
      for(let ho in this.headersOptions){
        for(let h in this.headers){
          if(this.headers[h].text === this.headersOptions[ho].text)
            index = h;
        }
      }

      this.headers.splice(index, 1);
      this.headers.splice(index, 0, this.headersOptions[inv]);
      this.refresh();
    },
    updateInventoryCount(){
      this.refresh();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
